// TableToolbar — the List-screen control bar: search box (left) + filter slot
// and actions (right), with an optional active-filter count and result count.
// Required element of the List screen type (Frontend Rules §8).
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { SearchIcon } from '../../icons/Icons';
import './table-toolbar.css';

export function TableToolbar({
  search,
  onSearch,
  searchPlaceholder = 'Search…',
  activeFilters = 0,
  resultCount,
  filters,
  actions,
  className,
}) {
  return (
    <div className={cx('table-toolbar', className)}>
      <div className="table-toolbar__left">
        {onSearch && (
          <div className="table-toolbar__search">
            <SearchIcon width={16} height={16} />
            <input
              type="search"
              value={search || ''}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={searchPlaceholder}
              aria-label="Search"
            />
          </div>
        )}
        {resultCount != null && <span className="table-toolbar__count">{resultCount} results</span>}
      </div>
      <div className="table-toolbar__right">
        {activeFilters > 0 && <span className="table-toolbar__badge">{activeFilters} active</span>}
        {filters}
        {actions}
      </div>
    </div>
  );
}

TableToolbar.propTypes = {
  search: PropTypes.string,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  /** Count of active filter chips (shows a badge). */
  activeFilters: PropTypes.number,
  resultCount: PropTypes.number,
  /** Filter controls slot (chips, selects). */
  filters: PropTypes.node,
  /** Right-side actions slot (buttons). */
  actions: PropTypes.node,
  className: PropTypes.string,
};

export default TableToolbar;
